var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var Config = {
    TAB_CLASS: "tab__anchor-active",
    ITEM_CLASS: "customer-story__item__visible",
    ITEM_SELECTOR: ".customer-story__item",
    TAB_SELECTOR: ".tab__anchor"
};
var Shuffle = /** @class */ (function () {
    // Grab initial tabs and video blocks.
    function Shuffle() {
        this.itemManifest = [];
        this.categories = [];
        this.blocks = [].slice.call(document.querySelectorAll(Config.ITEM_SELECTOR));
        this.tabs = [].slice.call(document.querySelectorAll(Config.TAB_SELECTOR));
    }
    // Initialize all dom nodes present on the page.
    Shuffle.prototype.initializeRefs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.indexAllVideoNodes().then(function (nodes) { return _this.indexCats(nodes); })];
            });
        });
    };
    // Index all video dom nodes on the page.
    Shuffle.prototype.indexAllVideoNodes = function () {
        var _this = this;
        return new Promise(function (resolve) {
            __spreadArray([], _this.blocks, true).forEach(function (element) {
                var node = {
                    $ref: element,
                    categories: JSON.parse(element.dataset.categories)
                };
                _this.itemManifest.push(node);
            });
            resolve(_this.itemManifest);
        });
    };
    // Index all categories and their respective DOM nodes.
    Shuffle.prototype.indexCats = function (nodes) {
        var _this = this;
        return new Promise(function (resolve) {
            __spreadArray([], _this.tabs, true).forEach(function (tab) {
                var data = tab.dataset.show || null;
                var category = {
                    $ref: tab,
                    category: data,
                    active: false,
                    indexedItems: data === "all"
                        ? nodes
                        : nodes.filter(function (node) { return node.categories.includes(data); })
                };
                tab.addEventListener("click", _this.handleClicks.bind(_this));
                _this.categories.push(category);
            });
            resolve(_this.categories);
        });
    };
    /**
     * On click, check to find the indexed category and it's items.
     * @param event
     */
    Shuffle.prototype.handleClicks = function (event) {
        event.preventDefault();
        var target = event.target;
        var clicked = this.categories.find(function (item) {
            if (!target)
                return false;
            return item.category === target.dataset.show;
        });
        if (!clicked)
            return false;
        this.showElements(clicked);
    };
    /**
     * Return the list of elements to select.
     * @param clickedCategory
     */
    Shuffle.prototype.showElements = function (clickedCategory) {
        // If the clicked category has no indexed items or is already active,
        // return false and bail outta here.
        if (!clickedCategory.indexedItems || clickedCategory.active)
            return false;
        // Set the cats to false if not clicked but keep the clicked one as true.
        this.categories.forEach(function (item) {
            var active = item.category === clickedCategory.category;
            if (active)
                return true;
            if (!item.indexedItems)
                return false;
            item.$ref.classList.remove(Config.TAB_CLASS);
            item.$ref.setAttribute('aria-expanded', 'false');
            item.indexedItems.forEach(function (indexedItem) {
                return indexedItem.$ref.classList.remove(Config.ITEM_CLASS);
            });
        });
        clickedCategory.$ref.classList.add(Config.TAB_CLASS);
        clickedCategory.$ref.setAttribute('aria-expanded', 'true');
        // Toggle classlist for all items.
        clickedCategory.indexedItems.forEach(function (item) {
            item.$ref.classList.toggle(Config.ITEM_CLASS);
        });
    };
    return Shuffle;
}());
export { Shuffle };
